module.exports = __webpack_public_path__ + "static/media/Sireesh.49208a75.jpg";